import { Card, Grid } from "@mui/material";
import { Autocomplete, Box, FormField } from "@maysoft/common-component-react";

import Header from "./header";
import PublishCell from "../PublishCell";
import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import { Mode } from "../../constants/enums";
import { ICodename, ICommunity, IMultiLanguageContent } from "../../commons/interfaces";
import { ICommunityError } from "../../hooks/community/edit/useData";

const BasicInfo = ({
    mode,
    data,
    error,
    language,
    typeData,
    onChangeValue,
    setLanguage,
}: {
    mode: Mode;
    language: string;
    data: ICommunity;
    typeData: ICodename[];
    error: ICommunityError;
    onChangeValue: (value: string | IMultiLanguageContent, key: keyof ICommunity) => void;
    setLanguage: React.Dispatch<React.SetStateAction<string>>;
}) => {
    const Strings = useStrings();
    return (
        <Card>
            <Box p={2}>
                <Header title={Strings.COMMUNITY.BASIC_INFO} description={""} defaultLanguage={language} setLanguage={setLanguage}>
                    {!Helpers.isNullOrEmpty(data?.id) && <PublishCell status={data.status} />}
                </Header>

                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <FormField
                            required
                            mode={mode}
                            maxLength={255}
                            label={Strings.COMMUNITY.NAME}
                            placeholder={Strings.COMMUNITY.INPUT_NAME}
                            defaultValue={data?.name}
                            errorMessage={error?.name}
                            onBlur={(value) => onChangeValue(value, "name")}
                            onFocus={(e: any) => (e.target.value = Helpers.checkMaxLengthTypeNumber(e.target.value, 100))}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Autocomplete
                            required
                            mode={mode}
                            isSelectedBox
                            defaultValue={data?.type}
                            data={typeData || []}
                            label={Strings.MESSAGE_TEMPLATE.TYPE}
                            errorMessage={error?.type || ""}
                            // disabled={!Helpers.isNullOrEmpty(data?.id)}
                            placeholder={Strings.MESSAGE_TEMPLATE.SELECT_TYPE}
                            onChange={(value) => onChangeValue(value, "type")}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormField
                            required
                            mode={mode}
                            multiline
                            label={Strings.COMMUNITY.DESCRIPTION}
                            placeholder={Strings.COMMUNITY.INPUT_DESCRIPTION}
                            defaultValue={Helpers.getDefaultValueMultiLanguage(data?.description, language)}
                            errorMessage={error?.description}
                            onBlur={(value) =>
                                onChangeValue(
                                    {
                                        ...data?.description,
                                        value: { ...data?.description?.value, [language]: value },
                                    },
                                    "description"
                                )
                            }
                            onFocus={(e: any) => (e.target.value = Helpers.checkMaxLengthTypeNumber(e.target.value, 255))}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Card>
    );
};

export default BasicInfo;
